import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
//import { IUsers } from '../user/IUsers';
@Injectable()
export class RegisterService {
    private _CountryUrl = JsonURL+'data/countries.json';
    private _StateUrl = JsonURL+'data/countries/';
    private _RegisterUrl = APIURL+'Users/registration';
    private _checkEmailUrl = APIURL+'Users/validEmail';
   //  private currentUser :IUsers ; 
    constructor(private _http: Http) { 
     //      this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
   
    }
    getCountry(): any  {
        return this._http.post(this._CountryUrl,[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getStateByCountry(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    isCheckEmail(email:string): any{
         let formData:FormData = new FormData();
         formData.append('email', email);
        return this._http.post(this._checkEmailUrl,formData)
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    UserRegister(form:any,userImg:File,userProfileImg:File): any  {

         let formData:FormData = new FormData();
         formData.append('firstName', form.firstName);
         formData.append('lastName', form.lastName);
         formData.append('username', form.username);
         formData.append('userPassword', form.userPassword);
         if(userImg!=null){
              formData.append('UserPhoto', userImg, userImg.name);
          }
          if(userProfileImg!=null){
              formData.append('UserIDProof', userProfileImg, userProfileImg.name);
          }
        return this._http.post(this._RegisterUrl,formData)
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
     private handleError(error: Response) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/register.service.ts